exports.sendBI = function sendBI() {return elementorySupport.getJSON(generateWebMethodUrl("sendBI","backend/bi-sender.jsw"), arguments, undefined, undefined)}